module.exports = __webpack_public_path__ + "img/vn_vn.954929c8.png";